import React, { PureComponent } from "react";

export default class XIcon extends PureComponent {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" {...this.props}>
				<path
					d="m10,1l-1,-1l-4,4l-4,-4l-1,1l4,4l-4,4l1,1l4,-4l4,4l1,-1l-4,-4l4,-4z"
					id="path"
				/>
			</svg>
		);
	}
}
